var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoverEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69332 13.0133C3.28666 13.0133 2.90666 12.8733 2.63332 12.6133C2.28666 12.2867 2.11999 11.7933 2.17999 11.26L2.42666 9.10001C2.47332 8.69334 2.71999 8.15334 3.00666 7.86001L8.47999 2.06667C9.84666 0.620007 11.2733 0.580007 12.72 1.94667C14.1667 3.31334 14.2067 4.74001 12.84 6.18667L7.36666 11.98C7.08666 12.28 6.56666 12.56 6.15999 12.6267L4.01332 12.9933C3.89999 13 3.79999 13.0133 3.69332 13.0133ZM10.62 1.94001C10.1067 1.94001 9.65999 2.26001 9.20666 2.74001L3.73332 8.54001C3.59999 8.68001 3.44666 9.01334 3.41999 9.20667L3.17332 11.3667C3.14666 11.5867 3.19999 11.7667 3.31999 11.88C3.43999 11.9933 3.61999 12.0333 3.83999 12L5.98666 11.6333C6.17999 11.6 6.49999 11.4267 6.63332 11.2867L12.1067 5.49334C12.9333 4.61334 13.2333 3.80001 12.0267 2.66667C11.4933 2.15334 11.0333 1.94001 10.62 1.94001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.56 7.3C11.5466 7.3 11.5266 7.3 11.5133 7.3C9.4333 7.09333 7.75996 5.51333 7.43996 3.44666C7.39996 3.17333 7.58663 2.92 7.85996 2.87333C8.1333 2.83333 8.38663 3.02 8.4333 3.29333C8.68663 4.90666 9.9933 6.14666 11.62 6.30666C11.8933 6.33333 12.0933 6.58 12.0666 6.85333C12.0333 7.10666 11.8133 7.3 11.56 7.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoverEditIcon);
export default __webpack_public_path__ + "static/media/hover_edit_icon.196c443f99783598098c5fee9b615ab7.svg";
export { ForwardRef as ReactComponent };